import { useEffect, useState } from 'react';
import { DESKTOP_BREAKPOINT, TABLET_BREAKPOINT, XL_BREAKPOINT } from './constants';
export var useScreenRecognition = function useScreenRecognition() {
  var _a = useState(false),
      isMobile = _a[0],
      setIsMobile = _a[1];

  var _b = useState(false),
      isTablet = _b[0],
      setIsTablet = _b[1];

  var _c = useState(false),
      isDesktop = _c[0],
      setIsDesktop = _c[1];

  var _d = useState(false),
      isXl = _d[0],
      setIsXl = _d[1];

  var handleResize = function handleResize() {
    var width = window.innerWidth;
    setIsMobile(width < TABLET_BREAKPOINT);
    setIsTablet(width >= TABLET_BREAKPOINT && width < DESKTOP_BREAKPOINT);
    setIsDesktop(width >= DESKTOP_BREAKPOINT && width < XL_BREAKPOINT);
    setIsXl(XL_BREAKPOINT <= width);
  };

  useEffect(function () {
    handleResize();
    window.addEventListener('resize', handleResize);
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, []);
  return {
    isMobile: isMobile,
    isTablet: isTablet,
    isDesktop: isDesktop,
    isXl: isXl
  };
};